<form id="identity-override-form" [formGroup]="authOverrideForm" (ngSubmit)="setAuth()" *ngIf="!error" hidden="true">
  <input
    id="identity-override-form-access-token"
    type="text"
    formControlName="accessToken"
    placeholder="accessToken"
    hidden="true" />
  <input
    id="identity-override-form-customer-slug"
    type="text"
    formControlName="customerSlug"
    placeholder="customerSlug"
    hidden="true" />
  <input
    id="identity-override-form-redirect-path"
    type="text"
    formControlName="redirectPath"
    placeholder="redirectPath"
    hidden="true" />
  <button id="identity-override-form-submit" type="submit">ok</button>
</form>
<div *ngIf="error" id="identity-override-error">
  {{ error | json }}
</div>
<div id="identity-override-access-token-in-use" *ngIf="currentAuthInfo$ | async as authInfo" hidden="true">
  {{ authInfo.accessToken }}
</div>
